<template>
  <div
    class="modal fade"
    id="MenuModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div
        class="modal-content"
        style="background-color: rgb(238 241 249); padding: 1em"
      >
        <button
          type="button"
          class="btn-close mb-1"
          data-bs-dismiss="modal"
          aria-label="Close"
          id="MenuModalCloseBTN"
        ></button>
        <div class="modal-body p-0">
            <div class="position-relative d-inline-block menu-item pt-2" v-for="(item,index) in cash.mainCategories" :key="item.id" @click="goPage(item.id)" >
                <div class="bg-light rounded shadow-sm" style="width: fit-content;margin-right: auto;margin-left: auto;">
                    <img :src="'https://radap.ir/'+item.img_url" class="card-img-top rounded" >
                </div>
                <h5 class="card-title text-center my-2 bg-transparent" style="font-size: 13px;font-weight: 700;">{{ item.name }}</h5>
                <span class="position-absolute top-0  translate-middle badge rounded-pill bg-danger" style="font-size: 10px;padding-top: 2px;right: 65%" v-if="item.badge">
                        {{item.badge}}
                </span>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useCash } from '@/store/cash';
import { onMounted } from 'vue';
import {useRouter} from 'vue-router';
let router = useRouter()
const cash = useCash()
onMounted(() => {
	cash.getMainCategories()
})

function goPage(id){
    document.getElementById('MenuModalCloseBTN').click()
	router.push({name:'Shops',params:{item:id}})
}
</script>

<style scoped>
img{
    width: 4rem;
    min-width: 4rem;
    max-width: 4rem;
    min-height: 4em;
    max-height: 4em;
}
.modal-body{
    display: flex;
    gap: 1em;
    flex-wrap: wrap;
    justify-content: center;
    flex: 1 1 auto;
}
.menu-item{
    width:29%; 
    padding: .1875rem;
    background-color: #fff;
    border: 1px solid #fff;
    border-radius: .75rem;
    box-shadow: 0 1px 0 rgb(58 61 66 / 6%), 0 8px 32px -16px rgba(0, 0, 0, .3);
    cursor: pointer;
    transition: all .2s ease-in-out 0s;
}

@media (max-width: 295px) {
    .menu-item {
        width: 100%;
    }
}

</style>